module.exports = __webpack_public_path__ + "img/sign-person.b70a4255.png";